import { useEffect, useState } from 'react';
import { theme } from 'pfm-ui-components';
import DEVICE_TYPE from '../constants/device';

const getDeviceType = (innerWidth) => {
  if (innerWidth < theme.layout.breakpoints.lg && innerWidth >= theme.layout.breakpoints.md) return DEVICE_TYPE.TAB;
  else if (innerWidth < theme.layout.breakpoints.md) return DEVICE_TYPE.MOBILE;
  return DEVICE_TYPE.DESKTOP;
};

export const useDeviceType = () => {
  const [device, setDevice] = useState(() => {
    return (global.window && getDeviceType(window.innerWidth)) || DEVICE_TYPE.DESKTOP;
  });
  const handleWindowResize = () => window && setDevice(getDeviceType(window.innerWidth));

  useEffect(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return device;
};

const getDeviceTypeUserGuide = (innerWidth) => {
  if (innerWidth < theme.layout.breakpoints.md) return DEVICE_TYPE.MOBILE;
  return DEVICE_TYPE.DESKTOP;
};

export const useDeviceTypeUserGuide = () => {
  const [device, setDevice] = useState(() => {
    return (global.window && getDeviceTypeUserGuide(window.innerWidth)) || DEVICE_TYPE.DESKTOP;
  });
  const handleWindowResize = () => window && setDevice(getDeviceTypeUserGuide(window.innerWidth));

  useEffect(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return device;
};